module.exports = __webpack_public_path__ + "img/loginBgNew.c15c7a35.jpeg";